import { render, staticRenderFns } from "./ModalInscripciones.vue?vue&type=template&id=884161c4&"
import script from "./ModalInscripciones.vue?vue&type=script&lang=js&"
export * from "./ModalInscripciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports